// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"401bdad5","230":"788ef90b","470":"31763381","539":"87ab462d","582":"26632332","614":"8740aab5","938":"5688afef"}[chunkId] + ".chunk.js";
};